import { enviroment } from "../../enviroment";
import { useAuthHttpClient } from "./useAuthHttpClient";
import { throwIfNotSuccess } from "./throwIfNotSuccess";

const API_URL = `${enviroment.apiUrl}/api/v1/HtmlToPdf`;

export function useHtmlToPdfBase64Service(): HtmlToPdfBase64Service {
    const { authFetch } = useAuthHttpClient();

    async function parse(html: string): Promise<string> {
        const body = {
            htmlContent: html
        };

        const response = await authFetch(API_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body)
        });
        throwIfNotSuccess(response);
        const data = (await response.json()) as { result: string };
        return data.result;
    }

    return {
        parse
    } as HtmlToPdfBase64Service;
}

export interface HtmlToPdfBase64Service {
    parse(html: string): Promise<string>;
}
